import { render, staticRenderFns } from "./cateredProductOrderSplitLog.vue?vue&type=template&id=9a6c6064&scoped=true&"
import script from "./cateredProductOrderSplitLog.vue?vue&type=script&lang=js&"
export * from "./cateredProductOrderSplitLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c6064",
  null
  
)

export default component.exports